import { Theme } from "@mui/material";

export const useStyles = (_theme: Theme) => ({
  searchInput: {
    width: { xs: "100%", md: "400px" },
  },
  boxHeader: {
    width: "100%",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 2,
    alignItems: "center",
  },
  boxStartContent: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 1,
    alignItems: "center",
  },
  boxActions: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 1,
    alignItems: "center",
  },
  buttonRefresh: () => ({
    minWidth: "25px",
    padding: "8px",
    lineHeight: 1,
    "& .rotating": {
      animation: "spin 1s linear infinite",
    },
    "@keyframes spin": {
      "0%": { transform: "rotate(0deg)" },
      "100%": { transform: "rotate(-360deg)" },
    },
  }),
});
